module.exports = __webpack_public_path__ + "static/media/icon-close-white.220c4e19.svg";